<template>
  <div class="layout-wrap" @click="handelClick">
    <el-container>
      <el-aside
        v-if="
          $route.name !== 'configurationPage' &&
          $route.name !== 'baConfigurationPage' &&
          $route.name !== 'videoConfigurationPage' &&
          $route.name !== 'doorConfigurationPage'
        "
      >
        <Aside @ChangeMenuPath="ChangeMenuPath" @userInfo="getUserInfo"></Aside>
      </el-aside>
      <el-container>
        <el-header height="50px">
          <Navbar
            :user="user"
            ref="Navbar"
            @ChangeMenuPath="ChangeMenuPath"
            @userInfo="getUserInfo"
          ></Navbar>
        </el-header>
        <el-main>
          <div
            class="show-menu"
            @click="showAside"
            v-if="
              $route.name !== 'configurationPage' &&
              $route.name !== 'baConfigurationPage' &&
              $route.name !== 'videoConfigurationPage' &&
              $route.name !== 'doorConfigurationPage'
            "
          >
            <i :class="elIcon"></i>
          </div>
          <p class="mypath" v-if="$route.name === 'home'">首页管理</p>
          <p class="mypath" v-else-if="$route.name === 'continent'">大洲管理</p>
          <p class="mypath" v-else-if="$route.name === 'country'">国家管理</p>
          <p class="mypath" v-else-if="$route.name === 'visaCategory'">
            分类管理
          </p>
          <p class="mypath" v-else-if="$route.name === 'applicantIdentity'">
            申请人身份管理
          </p>
          <p class="mypath" v-else-if="$route.name === 'applicantInformation'">
            资料管理
          </p>
          <p class="mypath" v-else-if="$route.name === 'electronicForm'">
            电子表单
          </p>
          <p class="mypath" v-else-if="$route.name === 'visa'">签证管理</p>
          <p class="mypath" v-else-if="$route.name === 'order'">
            订单管理
            <el-link
              type="primary"
              underline
              @click="returnBack"
              v-if="setOrderBid"
              >返回上一级</el-link
            >
          </p>
          <p class="mypath" v-else-if="$route.name === 'account'">账号管理</p>
          <p class="mypath" v-else-if="$route.name === 'accountChecking'">
            交行报表
          </p>
          <p class="mypath" v-else-if="$route.name === 'financeData'">
            对账报表
          </p>
          <p class="mypath" v-else-if="$route.name === 'consularDistrict'">
            领区管理
          </p>
          <p class="mypath" v-else-if="$route.name === 'basicInfo'">客服电话</p>
          <p class="mypath" v-else-if="$route.name === 'visaTerm'">条约管理</p>
          <p class="mypath" v-else-if="$route.name === 'visaUserProtocol'">
            用户协议
          </p>
          <p class="mypath" v-else-if="$route.name === 'userPrivacy'">
            隐私条款
          </p>
          <p class="mypath" v-else>{{ setTabsList.menuName }}</p>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Navbar from './Navbar';
import Aside from './Aside';
// import Tabs from './tabs';
import { mapGetters } from 'vuex';
export default {
  name: 'Layout',
  data() {
    return {
      pathName: '',
      user: {},
      doneTodos: false,
      elIcon: 'el-icon-d-arrow-left',
    };
  },
  mounted() {},
  methods: {
    ChangeMenuPath(pathName) {},
    getUserInfo(user) {},
    handelClick() {},
    returnBack() {
      this.$store.commit('setOrderString', '');
    },
    showAside() {
      this.doneTodos = !this.doneTodos;
      if (this.doneTodos) {
        this.elIcon = 'el-icon-d-arrow-right';
      } else {
        this.elIcon = 'el-icon-d-arrow-left';
      }
      this.$store.commit('allowAside');
    },
  },
  computed: {
    ...mapGetters(['setOrderBid']),
  },
  components: {
    Navbar,
    Aside,
    // Tabs
  },
};
</script>
<style lang="scss">
.layout-wrap {
  height: 100%;
  .el-container {
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .el-header {
    padding: 0;
  }
  .el-aside {
    width: auto !important;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .el-main {
    background: #f2f2f2;
    position: relative;
    .show-menu {
      width: 15px;
      height: 60px;
      background: url(../../assets/imgs/menu-show.png) no-repeat center;
      position: absolute;
      top: 14px;
      left: 0;
      i {
        line-height: 60px;
        color: #fff;
      }
    }
    .mypath {
      font-size: 14px;
      font-weight: bold;
      line-height: 56px;
      // background: #fff;
      margin: 4px 16px;
      padding-left: 20px;
      color: rgba(25, 137, 250, 1);
      .el-link {
        margin-left: 15px;
        line-height: 14px;
        text-decoration: underline;
      }
      .page-name {
        float: right;
        padding-right: 20px;
      }
    }
    .my-item-path {
      font-size: 14px;
      line-height: 54px;
      font-weight: bold;
      background: #fff;
      margin: 0 20px;
      padding: 0 20px;
      span {
        display: inline-block;
        height: 14px;
        width: 2px;
        margin-right: 10px;
        background: #5686e7;
        vertical-align: middle;
      }
    }
  }
}
</style>
